import React, { useEffect, useState } from "react";
import {
  Container, Grid, makeStyles, Button, Typography, CardHeader, CardContent, Box, Card, Divider, useTheme, colors, MenuItem, Select, InputLabel, Avatar, IconButton, Collapse, CardActions,
} from "@material-ui/core";
import Page from "components/Page";
import serviciosPTareas from "utils/serviciosPTareasAsignadas";
import { Header, Tabla, ModalFormulario, ModalGeneral } from "components";
import { useForm } from "react-hook-form";
import getErrorMessage from "utils/getErrorMessage";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import FormularioCerrar from "views/Panel/Components/FormularioCerrarTarea";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },

  timeline: {
    minHeight: "200px",
  },
  header: {
    position: "absolute",
    bottom: "8px",
    left: "16px",
  },
}));

const Paneltareas = ({permisos, usuario}) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const { state } = useLocation();
  // const [expanded, setExpanded] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const [mAdvertencia, setMAdvertencia] = useState({ open: false, titulo: "" });
  const { register, handleSubmit, errors, watch, setValue, reset, getValues } = useForm();
  const [modal, setModal] = useState({open: false, titulo: "", item: [], t: "", index: "",});
  const cerrarMensaje = () => setMensaje({ ...mensaje, open: false });
  const cerrarAdvertencia = () => setMAdvertencia({ open: false, titulo: "" });
  const cerrarModal = () => {setModal({ open: false, titulo: "" });};
  const respuesta = (onSuccess) => (status, mensaje, data) => {
    if (status > 0) {
      onSuccess();
      setData(data.original);
      cerrarAdvertencia();
      cerrarModal();
    }
    setMensaje({ open: true, status: status, value: mensaje });
  };

  const abrirAdvertencia = (data) =>
    setMAdvertencia({
      open: true,
      titulo: "ADVERTENCIA",
      mensaje:
        "Asegúrese  de que todos los datos son correctos antes de continuar con esta acción.",
      aceptar: (event) => modal.guardar({ ...data, id: modal.id }),
  });

  // const cambioEstatus = (accion) => (item) => {
  //   let title = "";
  //   let mnsj =
  //     "¿Está seguro de cambiar el estatus a la tarea #" +
  //     item.idsolicitud +
  //     "?";
  //   let propModal = "";
  //   let cambio = null;

  //   if (accion == "cerrar") {
  //     title = "CERRAR TAREA";
  //     // mnsj =
  //     //   "¿Está seguro de enviar su propuesta de la solicitud #" +
  //     //   item.idsolicitud +
  //     //   " a dirección de TI?";
  //     cambio = 13;
  //   }

  //   propModal = {titulo: title, mensaje: mnsj,};

  //   setMAdvertencia({
  //     open: true,
  //     item,
  //     edicionEspecial: false,
  //     width: "sm",
  //     paddingDisabled: false,
  //     aceptar: () =>
  //       servicios.cambioEstatus({
  //         idsolicitud: item.idsolicitud,
  //         idtarea: item.idtarea,
  //         idestatus: cambio,
  //         tipo: accion,
  //       }),
  //     ...propModal,
  //   });
  // };

  const clickCerrarT = (item) => {
    setModal({
      open: true,
      item: {
        ...item,
      },
      id: item.idtarea,
      Formulario: FormularioCerrar,
      guardar: updateTareaCerrar,
      tipo: "cerrarTarea",
      t: "update",
      titulo: "TAREA",
    });
  };
  const updateTareaCerrar = (data) => {
    serviciosPTareas.cambioEstatus(respuesta(cerrarModal),setCargando,{...data, idestatus: 13});
  };

  const navigate = useNavigate();
  const location = useLocation();
  const clickPanelSol = (item) => {
    navigate("/Panel", { state: { id: item.idsolicitud } });
  };

  useEffect(() => {
    if (modal.open && modal.tipo) {
      
      if (modal.tipo == "updateTarea") {
        register("titulo", {
          required: { value: true, message: "Campo requerido" },
        });
        register("prop_inicio", {
          required: { value: true, message: "F. INICIO ES REQUERIDA" },
          minLength: { value: 1, message: "MÍNIMO 1 CARÁCTERES" },
        });
        register("prop_fin", {
            required: {value: true, message: "F. FIN ES REQUERIDA"},
            minLength: {value: 1,message: "MÍNIMO 1 CARÁCTERES"},
        });
      } 
    }
  }, [modal]);

  useEffect(() => {
    if (modal.tipo == "updateTarea") {
      //Tareas
      if (modal.open && modal.item) {
        //SI se está editando           
        setValue("prop_inicio", modal.item.fecha_inicio? modal.item.fecha_inicio : modal.item.prop_inicio);
        setValue("prop_fin", modal.item.fecha_termino? modal.item.fecha_termino : modal.item.prop_fin);
      } 
    } 
  }, [modal]);

  useEffect(() => {
    serviciosPTareas.getTareasAsignadas(
      (data) => {
        setData(data);
      },
      setCargando,
      {}
    );
  }, []);

  const acciones = []; // { label: "Nueva orden", icon: <AddBox />, click: clickNuevo, disabled: !permisos.crear },
  const accionesFila = [
    {
      label: "GESTIONAR SOLICITUD",
      onClick: clickPanelSol,
      enabled: (item) => [12].includes(item.idestatus),
    },
    {
      label: "CERRAR TAREA",
      onClick: clickCerrarT,
      notificacion: true,
      enabled: (item) => [12].includes(item.idestatus),
    },
  ];

  // const handleChangeEstatus = (event, value) => {
  //   console.log(value);
  //   if (value) {
  //     setValue("estatus", value);

  //     // setDato({ ...datosF, estatus:  });
  //     if (value.id != null) {
  //       // serviciosSolicitudes.getSolicitudesByestatus(
  //       //   (data) => {
  //       //     setData(data.solicitudes);
  //       //   },
  //       //   setCargando,
  //       //   {
  //       //     ...datosF,
  //       //     estatus: value.id,
  //       //   }
  //       // );
  //     }
  //   } else {
  //     setValue("estatus", null);
  //   }
  // };

  const options = [
    // {id: 1,nestatus: "TODAS",},
    // {id: 0,nestatus: "CANCELADAS",},
  ];

  const columns = [
    { label: "#", name: "idtarea", filtrar: true },
    { label: "TÍTULO", name: "titulo", filtrar: true },
    { label: "PRIORIDAD", name: "nprioridad", filtrar: true },
    { label: "SOLICITUD", name: "nsolicitud", filtrar: true},
    { label: "SISTEMA", name: "nproyecto", filtrar: true },
    { label: "F. INICIO", name: "prop_inicio", filtrar: true },
    { label: "F. FIN", name: "prop_fin", filtrar: true }
  ];
  return (
    <Page
      className={classes.root}
      title="Panel de tareas asignadas"
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <Header title="PANEL" subtitle="Tareas asignadas" />
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Tabla
              keyTabla='iniTareas'
              rows={data}
              columns={columns}
              accionesTabla={acciones}
              // optionsSelect={options}
              register={register}
              // change={handleChangeEstatus}
              errors={getErrorMessage(errors)}
              watch={watch}
              accionesFila={accionesFila}
              isSeleccionable={false}
              filterGeneralDisabled={false}
              columnKey={"idtarea"}
              DetailByrow={row=><Box margin={1}>
                  <Typography variant="body1">
                      <b>Descripción:</b>&nbsp;{row.descripcion}&nbsp;
                  </Typography>
              </Box>}
            />
          </Grid>
        </Grid>
        <ModalGeneral
          open={mAdvertencia.open}
          titulo={mAdvertencia.titulo}
          width={mAdvertencia.width}
          paddingDisabled={mAdvertencia.paddingDisabled}
          ContenidoMensaje={mAdvertencia.mensaje}
          OnCerrar={cerrarAdvertencia}
          acciones={
            <React.Fragment>
              {Boolean(mAdvertencia.aceptar) && (
                <Button color="primary" onClick={mAdvertencia.aceptar}>
                  ACEPTAR
                </Button>
              )}
            </React.Fragment>
          }
        >
          {mAdvertencia.Formulario && (
            <mAdvertencia.Formulario
              setMensaje={setMensaje}
              setCargando={setCargando}
              tipo={mAdvertencia.tipo}
              edicionEspecial={mAdvertencia.edicionEspecial}
              permisos={permisos}
              datoS={mAdvertencia.item}
              usuario={usuario}
              guardar={mAdvertencia.guardar}
              // servicios={servicios}
              {...mAdvertencia.props}
            />
          )}
        </ModalGeneral>

        <ModalFormulario
          open={modal.open}
          titulo={"CERRAR " + modal?.titulo + " # "+ modal?.item?.idtarea}
          aceptar={handleSubmit(abrirAdvertencia)}
          OnCancelar={cerrarModal}
        >
          {modal.Formulario && (
            <modal.Formulario
              register={register}
              setValue={setValue}
              getValues={getValues}
              watch={watch}
              setMensaje={setMensaje}
              errors={getErrorMessage(errors)}
              defaultItem={modal.item || {}}
              id={modal?.item?.idtarea}
            />
          )}
        </ModalFormulario>
      </Container>
    </Page>
  );
};

export default Paneltareas;
